<template>
  <div class="container">
    <div class="row">
      <div id="column-left" class="col-sm-3 hidden-xs column-left">
        <div class="banner">
          <div class="item">
            <a href="#"
              ><img
                src="../assets/image/banners/LeftBanner.jpg"
                alt="Left Banner"
                class="img-responsive"
                style="width:100%"
            /></a>
          </div>
        </div>

        <div class="column-block">
          <div id="complementary-products"></div>
          <div id="recently-viewed"></div>
        </div>
      </div>
      <div id="content" class="col-sm-9">
        <product-details :data="getListProducts()"></product-details>

        <div id="other-products"></div>
      </div>
    </div>
  </div>
</template>

<script>
import productData from "../data/product.json";
import ProductDetails from "../components/product/ProductDetails.vue";
import RelatedProducts from "../components/product/RelatedProducts.vue";
import BestSellers from "../components/product/BestSellers.vue";
import Latest from "../components/product/Latest.vue";
import Specials from "../components/product/Specials.vue";

export default {
  components: {
    ProductDetails,
    RelatedProducts,
    BestSellers,
    Latest,
    Specials
  },
  data() {
    return {
      productId: this.$route.params.id,
      deviceId: ""
    };
  },
  methods: {
    getListProducts() {
      let data = productData.product.filter(p => p.id == this.productId)[0];
      data.price = data.price.replace(/[ ,.]/g, "");
      return data;
    }
  },
  created() {
    const data = this.getListProducts();
    console.log(data, " << product");

    dengage("getContactKey", function(contact_key) {
      window.sgfLayer = {
        page: {
          pageUrl: "https://showcase.dengage.com/#/product/",
          category: "Product Page",
          subCategory: data.category
        },
        product: {
          productId: data.id,
          title: data.name,
          inStock: data.availability,
          url: "https://showcase.dengage.com/#/product/" + data.id,
          image: data.image[0],
          category: data.category,
          categories: [data.category],
          brand: data.brand,
          price: data.price,
          oldPrice: data.oldPrice,
          currency: "USD",
          colors: data.colors,
          sizes: data.sizes
        }
      };
      if (contact_key) {
        window.sgfLayer.common = {
          userId: contact_key
        };
      } else {
        dengage("getDeviceId", function(device_id) {
          window.sgfLayer.common = {
            userId: device_id
          };
        });
      }
    });

    /*dengage("sendDeviceEvent", "user_events", {
      event_type: "page_view",
      page_url: window.location.href,
      page_type: "product",
      page_title: data.name,
      product_id: data.id
    });*/
    /*dataLayer.push({
      event: 'dengage_event',
      dengage_table_name: 'user_events',
      dengage_event_data: {
        event_type: "page_view",
        page_url: window.location.href,
        page_type: "product",
        page_title: data.name,
        product_id: data.id
      }
    });*/
    dengage("ec:pageView", {
      page_type: "product",
      product_id: data.id
    });
    //collector.productDetail(data.id, parseInt(data.price), 0, 'USD', 0, localStorage.getItem('contact_key'))
  },
  mounted() {
    dengage('setNavigation', {name: 'product'});
    $(this.$refs.relatedSlider).owlCarousel({
      items: 4,
      navigation: true,
      pagination: false,
      itemsDesktop: [1199, 3],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 2],
      itemsTabletSmall: false,
      itemsMobile: [479, 1]
    });
  }
};
</script>

<style scoped>
#column-left .banner {
  float: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Product.vue